import React from 'react'

import { PermissionChecker } from '../../session'
import ControlledModal from '../../../components/modals/ControlledModal'
import EditWidgetForm from './EditWidgetForm'
import ModalHeader from './ModalHeader'
import ScreenItemLoader from './_load/ScreenItemLoader'

const EditWidgetModal = props => {
  return (
    <ControlledModal width="82rem" disableClickOutside {...props}>
      <PermissionChecker permission={'setupScreen'}>
        <ScreenItemLoader>
          <ModalHeader />
          <EditWidgetForm />
        </ScreenItemLoader>
      </PermissionChecker>
    </ControlledModal>
  )
}

export default EditWidgetModal
